
import Vue from 'vue';
import store from '@/store';
import axios from 'axios';
import router from '@/router' 
import redirectLogin from '@/helper/redirect';

console.log(redirectLogin)

const http = axios.create({
  baseURL: process.env.VUE_APP_API_DOMAIN,
});


http.interceptors.request.use(
  config => {
    const accessToken = store.getters['auth/token'];
    if (accessToken) {
      config.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }
    const lang = store.getters['lang/locale'];
    config.baseURL = process.env.VUE_APP_API_DOMAIN + `/${lang}/api/`;
    return config;
  },
  error => Promise.reject(error),
);
http.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (!error.response) {
      Vue.notify({
        group: 'notification',
        title: 'Service Under Maintenance',
        type: 'error',
        speed: 1000,
        // text: 'Service Under Maintenance',
      });
      // router.push('/maintenance');
    }
    const errorCode = error.response.status;
    var title = '';
    var message = '';
    if (errorCode === 401) {
      title = 'Login required';
      message = 'Please sign in again!';
      store.dispatch('auth/Clear');
      // router.push('/')

      Vue.notify({
        group: 'notification',
        title: title,
        type: 'error',
        speed: 1000,
        text: message,
      }); 
      window.location.href = redirectLogin;

    } else if (errorCode === 500) {
      title = 'Internal Server Error';
      message =
        'There is an error on our server, please contact admin or try again later!';
      // router.push('/maintenance');
    } else if (errorCode === 400) {
      title = 'Bad Request';
      message = error.response.data.message;
    } else if (errorCode === 404) {
      // title = 'Not Found';
      // message = error.response.data.message;
    } else if (errorCode === 429) {
      title = 'System in buzy';
      message = error.response.data.message;
      router.push('/maintenance');
    }

    // Vue.notify({
    //   group: 'notification',
    //   title: title,
    //   type: 'error',
    //   speed: 1000,
    //   text: message,
    // });

  },

);



const HttpPlugin = {
  install(V, options) {
    V.prototype.$http = http;
  },
};

Vue.use(HttpPlugin);

export default http;